// @flow

export const COPY_STATUS = Object.freeze({
  START: 'start',
  COMPLETE: 'complete',
  ERROR: 'error',
});

export type CopyEvent = $Values<typeof COPY_STATUS>;

export type CopyReducerState = CopyEvent;

export const CopyReducer = (state: CopyReducerState, event: CopyEvent) => event;
